import { Injectable } from '@angular/core';
import {HttpClient,HttpHeaders} from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
import { HaEditIcdModal } from '../models/HaEditIcd.model';

@Injectable()
export class ImportExportCodesService {

  constructor(private http:HttpClient) { }
  getIcdTree(){
      return this.http.get(globalAdd.Paneladdress+'api/HA/ICD/getIcdTree');
    }

  uploadIcdExcel(File: File) {
    const upload: FormData = new FormData();
    upload.append("upload", File);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(globalAdd.Paneladdress + 'api/HA/ImpExp/importIcdData', upload, { headers, reportProgress: true, observe: 'events' });
  }

  getCptTree(){
    return this.http.get(globalAdd.Paneladdress+'api/HA/CPT/getCptTree');
  }

  uploadCptExcel(File: File) {
    const upload: FormData = new FormData();
    upload.append("upload", File);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(globalAdd.Paneladdress + 'api/HA/ImpExp/importCptData', upload, { headers, reportProgress: true, observe: 'events' });
   }

  getIcdAllData(){
    return this.http.get(globalAdd.Paneladdress+'api/HA/ICD/getIcdAllData');
  }

  updateIcdData(icd:HaEditIcdModal){
    return this.http.post(globalAdd.Paneladdress + 'api/HA/ICD/updateIcdData',icd);
  }

  insertIcdData(icd:HaEditIcdModal){
    return this.http.post(globalAdd.Paneladdress + 'api/HA/ICD/insertIcdData',icd);
  }

  getCptAllData(){
    return this.http.get(globalAdd.Paneladdress+'api/HA/CPT/getCptAllData');
  }

  updateCptData(cpt:HaEditIcdModal){
     return this.http.post(globalAdd.Paneladdress + 'api/HA/CPT/updateCptData',cpt);
  }

  insertCptData(cpt:HaEditIcdModal){
      return this.http.post(globalAdd.Paneladdress + 'api/HA/CPT/InsertCptData',cpt);
  }

  getAllIcdNames() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/ICD/getAllIcdNames' );
  }

  getAllCptNames() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/CPT/getAllCptNames' );
  }

}
